import fonts from '../theme/foundations/fonts'

const baseStyle = {}

const defaultProps = {
  size: 'md',
  lineHeight: 'normal',
}

const sizes = {
  xs: {
    fontSize: 'var(--vui-font-size-xs)',
  },
  sm: {
    fontSize: 'var(--vui-font-size-sm)',
  },
  md: {
    fontSize: 'var(--vui-font-size-md)',
  },
  lg: {
    fontSize: 'var(--vui-font-size-lg)',
  },
  xl: {
    fontSize: 'var(--vui-font-size-xl)',
  },
}

const variants = {
  label: {
    fontWeight: 'var(--vui-label-font-weight)',
    lineHeight: 'var(--vui-label-line-height)',
  },
  input: {
    fontWeight: 'var(--vui-input-font-weight)',
    lineHeight: 'var(--vui-input-line-height)',
  },
  caption: {
    fontWeight: 'var(--vui-caption-font-weight)',
    lineHeight: 'var(--vui-caption-line-height)',
  },
  navigation: {
    fontWeight: 'var(--vui-navigation-font-weight)',
    lineHeight: 'var(--vui-navigation-line-height)',
  },
  caps: {
    textTransform: 'var(--vui-caps-text-transform)',
    fontWeight: 'var(--vui-caps-font-weight)',
    lineHeight: 'var(--vui-caps-line-height)',
  },
  button: {
    fontWeight: 'var(--vui-button-font-weight)',
    lineHeight: 'var(--vui-button-line-height)',
  },
  mono: {
    fontFamily: fonts.mono,
  },
}

export default {
  baseStyle,
  defaultProps,
  sizes,
  variants,
}
